import { functionsBase } from '../config/functionsBase';

const FUNCTIONS_BASE = functionsBase(
  process.env.NODE_ENV === 'production'
    ? '/.netlify/functions'
    : 'http://localhost:8891/.netlify/functions'
);

export async function createPixPayment({
  planId,
  billing,
  discordId,
  discordUsername,
  minecraftNick,
  promoCode,
}) {
  const response = await fetch(`${FUNCTIONS_BASE}/create-pix-payment`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      planId,
      billing,
      discordId,
      discordUsername,
      minecraftNick,
      promoCode: promoCode || undefined,
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Erro ao criar PIX (${response.status})`);
  }
  if (!data.qrCode) {
    throw new Error('QR Code PIX não retornado');
  }
  return data;
}

export async function getPixPaymentStatus(paymentId) {
  const response = await fetch(`${FUNCTIONS_BASE}/get-pix-payment-status`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ paymentId }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Erro ao consultar PIX (${response.status})`);
  }
  return data;
}

/** Só desenvolvimento local — libera VIP sem cobrança. */
export async function simulatePixPayment({
  planId,
  billing,
  discordId,
  minecraftNick,
  paymentId,
}) {
  const response = await fetch(`${FUNCTIONS_BASE}/simulate-pix-payment`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      planId,
      billing,
      discordId,
      minecraftNick,
      paymentId,
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Erro ao simular PIX (${response.status})`);
  }
  return data;
}
